<template>
  <div class='cusLayer on orderHistoryDetail full' id='orderDetailList'>
    <div class="cusHd">
      <div class="in">
        <h1 class="tit">{{ $t("viewOrderHistory") }}</h1>
        <span class="tag" v-if="appOrder.qrType == 0">{{
          $t("orderInStore")
        }}</span>
        <span class="tag" v-else-if="appOrder.qrType == 1">{{
          $t("orderForDelivery")
        }}</span>
        <span v-if="fullVUi || appFlag" class="tag">
          {{
            this.companyType == 5
              ? $t("OrderPage.shopping")
              : $t(
                  `${getOrderType(
                    appFlag ? appOrder.packingFlag : order.packingFlag
                  )}`
                )
          }}
        </span>
        <button class="btnCloseModal" @click="removePopUp()">
          {{ $t("close") }}
        </button>
      </div>
    </div>

    <div class="order-container" data-status="order"  id="orderContainer">
      <div v-if="isPickedUp" class="status-display check">
        <p class="status-msg">픽업이 완료되었습니다.</p>
      </div>
      <div v-else-if="isDelivered || isDeriveredByAgecies" class="status-display check">
        <p class="status-msg">배달이 완료되었습니다.</p>
      </div>
      <div v-else-if="isCancelled" class="status-display cancel">
        <p class="status-msg">취소된 주문입니다.</p>
      </div>
      <!-- 포장,배달현황 (step-1 ~ step-4)
        step-1 : 주문완료
        step-2 : 상품 준비중
        step-3 : 상품 준비완료 
        step-4 : 배달 중
      -->
      <div v-else>
        <div class="time-container" v-if="isDeliveryOrder && appOrder?.arriveTime">
        <!-- <div class="time-container"> -->
          <p class="title">{{appOrder.arriveTime}}분 도착예정</p>
            <p class="sub-title">
              도착 예정 시간은 교통 및 배달 상황에 따라 달라질 수 있습니다.
            </p>
        </div> 
        <div class="step-container">
            <!-- <div class="status-mover">
              <div class="status-small"></div>
            </div>

            <div class="progress-steps" v-if="isDeliveryOrder">
              <div class="step" data-step="0">
                <div class="step-circle"></div>
                <div class="step-label">주문완료</div>
              </div>
              <div class="step" data-step="1">
                <div class="step-circle"></div>
                <div class="step-label">조리 중</div>
              </div>
              <div class="step" data-step="2">
                <div class="step-circle"></div>
                <div class="step-label delivery" ></div>
              </div>
              <div class="step" data-step="3" >
                <div class="step-circle"></div>
                <div class="step-label fin"></div>
              </div>
            </div>
            <div class="progress-steps" v-else>
              <div class="step" data-step="0">
                <div class="step-circle"></div>
                <div class="step-label">주문완료</div>
              </div>
              <div class="step" data-step="1">
                <div class="step-circle"></div>
                <div class="step-label">조리 중</div>
              </div>
              <div class="step" data-step="2">
                <div class="step-circle"></div>
                <div class="step-label ready"></div>
              </div>
              <div class="step" data-step="3">
                <div class="step-circle"></div>
                <div class="step-label pickup"></div>
              </div>
            </div> -->
          <div class="step-box">
            <ul class="step-list" :class="orderStepStatus" v-if="isDeliveryOrder">
              <li data-step="0">
                <span>주문완료</span>
              </li>
              <li data-step="1">
                <span>상품 준비중</span>
              </li>
              <li data-step="2">
                <span>상품 준비완료</span>
              </li>
              <li data-step="3">
                <span>배달 중</span>
              </li>
            </ul>
            <ul class="step-list col-3" :class="orderStepStatus" v-else>
              <li>
                <span>주문완료</span>
              </li>
              <li>
                <span>상품 준비중</span>
              </li>
              <li>
                <span>상품 준비완료</span>
              </li>
            </ul>
          </div>
          <div class="map-container">
            <div v-if="isDeliveryOrder " class="location">
              배달거리 <span>{{`${appOrder.deliveryDistance}Km`}}</span>
            </div>
            <div v-if="appOrder.distance" class="location">
              가게위치 <span>{{`${appOrder.distance}Km`}}</span>
            </div>
            <!-- <button class="btn-map">지도보기</button> -->
          </div>
        </div>
      </div>
      <div class="order-detail-container" v-if="appOrder.order && appOrder.order.length">
          <p>{{ appOrder.order[0].storeName }}</p>
          <ul class="order-detail-date">
            <li>주문일시</li>
            <li>{{ appOrder.orderTime }}</li>
          </ul>
          <ul class="order-detail-number">
            <li>주문번호</li>
            <li>{{appOrder.orderNum ? appOrder.orderNum : '-'}}</li>
          </ul>
        </div>
    </div>
      <div class="h-8px"></div>
    <div class='cusCnt'>
      <div class='in'>
        <div v-for='store in appOrder.order' :key='store.storeCode' class='box'>
          <ul class='orderList'>
            <li v-for='menu in store.menus' :key='menu.orderMenuId' class='li'>
              <OrderMenuItem :menu='menu'/>
            </li>
          </ul>
        </div>
      </div>
      <div class='orderInfo'>
        <div v-if='checkStringData(appOrder.address)' class='detail_Box'>
          <h3 class='cont_Tit'>{{$t('deliveryAddress')}}</h3>
          <div class='gray_Title'><p>{{appOrder.address }}</p></div>
        </div>
        <div v-if='checkStringData(appOrder.phone)' class='detail_Box'>
          <h3 class='cont_Tit' v-if="appOrder.safeNumber">{{$t('phoneNumber')}} / 안심번호</h3>
          <h3 class='cont_Tit' v-else>{{$t('phoneNumber')}}</h3>
          <div class='gray_Title' v-if="appOrder.safeNumber"><p>{{appOrder.phone }} / {{ appOrder.safeNumber }}</p></div>
          <div class='gray_Title' v-else><p>{{appOrder.phone}}</p></div>
          <div class="safeNumInfo">안심번호는 주문결제 후 최대 24시간 동안 유효합니다. </div>
        </div>
        <div v-if='checkStringData( appOrder.toOwner )' class='detail_Box'>
          <h3 class='cont_Tit'>{{$t('requestNote')}}</h3>
          <div class='gray_Title'><p>{{ appOrder.toOwner }}</p></div>
        </div>
        <div v-if='checkStringData( appOrder.toRider )' class='detail_Box'>
          <h3 class='cont_Tit'>{{this.companyType===5 ? $t('OrderPage.shoppingDesc') : $t('OrderPage.deliveryDesc')}}</h3>
          <div class='gray_Title'><p>{{ appOrder.toRider }}</p></div>
        </div>
        <div v-if=' appOrder.spoonFlag !== undefined && this.companyType != 5' class='detail_Box'>
          <h3 class='cont_Tit'>{{$t('OrderPage.plasticSpoons')}}</h3>
          <div class='gray_Title'>
            <p>{{appOrder.spoonFlag ? $t('OrderPage.need') : $t('OrderPage.dontNeed')}}</p>
          </div>
        </div>
      </div>
      <div>
        <div class='finalTotal'>
          <ul class='orderTotal'>
            <li class='item'>
              <span class='tit'>{{$t('totalOrderAmount')}}</span>
              <span class='price'>{{formatComma(appOrder.orderPrice)}}{{$t('MoneyUnit')}}</span>
            </li>
            <li v-if='isDeliveryOrder' class='item'>
              <span class='tit'>{{this.companyType == 5 ? '배송비' : '배달비'}}</span>
              <span class='price'>{{formatComma(appOrder.riderFee )}}{{$t('MoneyUnit')}}</span>
            </li>
            <li v-if='appOrder.storeExtraFee' class='item'>
              <span class='tit'>추가 배달비 ({{ appOrder.townshipName }})</span>
              <span class='price'>{{formatComma( appOrder.storeExtraFee )}}{{$t('MoneyUnit')}}</span>
            </li>
            <li v-if= 'appOrder.usePoint' class='item'>
              <span class='tit'>사용 포인트</span>
              <span class='price'>-{{formatComma( appOrder.usedPoint )}}P</span>
            </li>
          </ul>
        </div>
      </div>
      <ul class='purchaseTotal'>
        <li class='item'>
          <div class='tit'>{{$t('totalPaymentAmount')}}</div>
          <div class='price'>{{formatComma( appOrder.totalPrice )}}
            <span class="won">{{$t('MoneyUnit')}}</span>
          </div>
        </li>
      </ul>
      <button  v-if="isPickedUp || isDelivered || isDeriveredByAgecies || isCancelled"
        @click="goOrderBillDetail" class="btn-check-bill">영수증 확인하기</button>
    </div>
  </div>
</template>

<script lang="js">
import OrderMenuItem from '@/components/Common/OrderMenuItem.vue'
import { SET_ORDER_SEQ } from '@/store/_actions/actionTypes'
import { ORDER_DETAIL } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: ORDER_DETAIL,
  props: {
    appOrder: {
      type: Object,
      required: true
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    appOrder: {
      handler (newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.setDelivery()
        }
      },
      deep: true,
      immediate: false
    }
  },
  components: { OrderMenuItem },
  computed: {
    order () { return this.$store.getters.order },
    fullVUi () { return this.$store.getters.fullVUi },
    isPickedUp () {
      return this.appOrder.orderProgressFlag === 3 && !this.isDeliveryOrder
    },
    isDelivered () {
      return this.appOrder.orderProgressFlag === 3 && !this.appOrder.agenciesFlag
    },
    isDeriveredByAgecies () {
      return this.appOrder.orderProgressFlag === 5
    },
    isCancelled () {
      return this.appOrder.orderProgressFlag === 4
    }
  },
  data () {
    return {
      isDeliveryOrder: true,
      companyType: this.$store.getters.companyType,
      orderStepStatus: 'step-1',
    }
  },
  // updated () {
  //   this.setDelivery()
  // },
  methods: {
    setDelivery () {
      this.isDeliveryOrder = this.appOrder.packingFlag === this.DELIVERY_ORDER
      let { orderProgressFlag} = this.appOrder
      // 조리중
      switch (orderProgressFlag) {
        case 1 :
          
          // status = 'cooking'
          // 배달: 상품 준비중, 레거시: 조리 중
          // 매장: 상품 준비중,  레거시: 조리 중
          this.orderStepStatus = 'step-2'
          break
        case 2:
          // 배달: 상품 준비완료, 레거시: 조리 완료
          // 매장: 상품 준비완료, 레거시: 조리 완료
          this.orderStepStatus = 'step-3'
          break
        case 3:
          if (this.isDeliveryOrder) {
            // 레거시: 배대사 사용할 경우 배달중, 일반 배달인 경우 배달완료
            // 현행: 배대사 사용할 경우 배달중, 일반 배달인 경우 배달완료(프로그래스 표시가 안되고 배달완료 문구 표시됨)
            this.orderStepStatus = 'step-4'
          } else {
            // 레거시: 매장, 포장인 경우 픽업완료
            // 현행: 상품 준비완료 (매장일 때 마지막 상태) 
            this.orderStepStatus = 'step-3'
          }
          break
        case 5:
          // 레거시: 배대사 배달완료
          // 현행: 배달 중
          this.orderStepStatus = 'step-4'
          break
      }
    },
    goOrderBillDetail () {
      const orderSeq = this.appOrder.orderSeq
      this.$store.commit(SET_ORDER_SEQ, orderSeq)
      this.$router.push(
        {
          name: 'OrderBillDetail'
        }
      )
    }
  },
  beforeDestroy () {
    this.removePopUp()
  }
})

</script>
<style lang="scss" scoped>
.cusHd {
  z-index: 9999;
}

.d-none {
  display: none;
}

.order-container {
  // max-width: 32.8rem;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  position: relative;
  line-height: 1.5;
  padding: 16px 16px 0; //2026-03-25
}

/* 토끼와 말풍선 컨테이너 - 숨김 */
.status-container {
  display: none;
}

/* 진행 상태 바 */
.progress-container {
  max-width: 100%;
  background: #fff6f4;
}

.progress-sub-container{
  position: relative;
  height: 23rem;
  padding-top: 9.6rem;
  max-width: 32.8rem;
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  margin: 0 auto;
}

.progress-line {
  position: absolute;
  top: 10rem;
  left: 4.8rem;
  right: 4.8rem;
  height: 0.2rem;
  background: #e5e7eb;
  border-radius: 0.2rem;
}

.progress-line-active {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: var(--primary);
  border-radius: 0.2rem;
  width: 0%;
  transition: width 0.8s ease-in-out;
}

.progress-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  padding-bottom: 2rem;
}

.step {
  text-align: center;
  flex: 1;
  position: relative;
}

.step-circle {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  border: 0.3em solid #e5e7eb;
  transition: all 0.3s ease;
  position: relative;
}

.step-circle.active {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

.step-circle.completed {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

.step-circle::after {
  content: "✓";
  font-size: 0.6rem;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.step-circle.completed::after {
  opacity: 1;
}

.step-label {
  font-size: 1.6rem;
  color: #b5b5b5;
  transition: color 0.3s ease;
}

.step.active .step-label {
  color: var(--primary);
}

.step.completed .step-label {
  color: var(--primary);
}

/* 이동 애니메이션 */
.status-mover {
  position: absolute;
  top: 2rem;
  left: calc(0% - -1.6rem);
  transition: left 0.8s ease-in-out;
  z-index: 3;
}

.status-small {
  width: 6rem;
  height: 6rem;
  /* background: #fff; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 0.5em 1.5em rgba(0, 0, 0, 0.15); */
  /* transition: all 0.3s ease; */
  position: relative;
}

.status-small::after {
  content: "?";
  font-size: 3rem;
  transition: all 0.3s ease;
}

/* 움직이는 스테이터스의 말풍선 */
.status-small::before {
  content: "주문을 확인 중이에요!";
  position: absolute;
  top: -5rem;
  left: 50%;
  transform: translateX(-50%);
  background: #ffe4dc;
  color: var(--primary);
  padding: 0.8em 1.5rem;
  border-radius: 1.5rem;
  font-size: 1.4rem;
  font-weight: bold;
  white-space: nowrap;
  z-index: 10;
}

/* 말풍선 꼬리 */
.status-small {
  --bubble-tail: "";
}

.status-small:after {
  background-image: url("../../assets/img/img-status-order.webp");
  content: "";
  width: 6.8rem;
  height: 5.2rem;
  background-size: 6.8rem;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.status-small:before {
  content: var(--bubble-text, "주문을 확인 중이에요!");
  position: absolute;
  top: 1rem;
  // left: 230%;
  left: 13.8rem;
  transform: translateX(-50%);
  background: #ffe4dc;
  color: #818181;
  padding: 0.8em 1.2rem;
  border-radius: 1.2rem 1.2rem 1.2rem 0;
  font-size: 1.3rem;
  font-weight: bold;
  white-space: nowrap;
  z-index: 10;
  /* transition: all 0.3s ease; */
}

/* 말풍선 삼각형 꼬리를 위한 추가 가상요소 효과
.status-mover::after {
  content: '';
  background-image: url('../../assets/img/arrow-8-order.svg');
  position: absolute;
  top: 4rem;
  // left: 98%;
   left: 5.9rem;
  width: 0.8rem;
  height: 0.8rem;
  z-index: 9;
transform: rotate(0deg);
} */

/* 상태별 스타일 */

.order-container[data-status="order"] .step[data-step="0"] .step-label,
.order-container[data-status="cooking"] .step[data-step="1"] .step-label,
.order-container[data-status="delivery"] .step[data-step="2"] .step-label,
.order-container[data-status="fin"] .step[data-step="3"] .step-label,
.order-container[data-status="ready"] .step[data-step="2"] .step-label,
.order-container[data-status="pickup"] .step[data-step="3"] .step-label {
  border-color: var(--primary);
  color: var(--primary);
}

.order-container[data-status="order"]
  .step[data-step="2"]
  .step-label.ready:after,
.order-container[data-status="cooking"]
  .step[data-step="2"]
  .step-label.ready:after,
.order-container[data-status="pickup"]
  .step[data-step="2"]
  .step-label.ready:after {
  content: "조리완료";
  font-size: 1.6rem;
  color: #b5b5b5;
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

.order-container[data-status="ready"]
  .step[data-step="2"]
  .step-label.ready:after {
  content: "조리완료";
  font-size: 1.6rem;
  font-weight: bold;
  color: var(--primary);
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

.order-container[data-status="ready"]
  .step[data-step="2"]
  .step-label.ready:after {
  content: "조리완료";
  font-size: 1.6rem;
  color: var(--primary);
  font-weight: bold;
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

.order-container[data-status="order"]
  .step[data-step="2"]
  .step-label.delivery:after,
.order-container[data-status="cooking"]
  .step[data-step="2"]
  .step-label.delivery:after,
.order-container[data-status="pickup"]
  .step[data-step="2"]
  .step-label.delivery:after {
  content: "배달 중";
  font-size: 1.6rem;
  color: #b5b5b5;
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

// .order-container[data-status='order'] :is(
//   .step[data-step='1'] .step-label,
//   .step[data-step='2'] .step-label:after,
//   .step[data-step='3'] .step-label:after
// ){
// color: #0d0d0d !important;
// }

.order-container[data-status="order"] .step[data-step="1"] .step-label,
.order-container[data-status="order"] .step[data-step="2"] .step-label:after,
.order-container[data-status="order"] .step[data-step="3"] .step-label:after,
.order-container[data-status="cooking"] .step[data-step="2"] .step-label:after,
.order-container[data-status="cooking"] .step[data-step="3"] .step-label:after,
.order-container[data-status="delivery"] .step[data-step="3"] .step-label:after,
.order-container[data-status="ready"] .step[data-step="3"] .step-label:after {
  color: #0d0d0d !important;
}

.order-container[data-status="order"] .step[data-step="0"] .step-label,
.order-container[data-status="cooking"] .step[data-step="1"] .step-label,
.order-container[data-status="delivery"] .step[data-step="2"] .step-label,
.order-container[data-status="ready"] .step[data-step="2"] .step-label {
  font-weight: bold;
}

.order-container[data-status="delivery"]
  .step[data-step="2"]
  .step-label.delivery:after {
  content: "배달 중";
  font-size: 1.6rem;
  color: var(--primary);
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

.order-container[data-status="order"]
  .step[data-step="3"]
  .step-label.fin:after,
.order-container[data-status="cooking"]
  .step[data-step="3"]
  .step-label.fin:after,
.order-container[data-status="delivery"]
  .step[data-step="3"]
  .step-label.fin:after,
.order-container[data-status="pickup"]
  .step[data-step="3"]
  .step-label.fin:after {
  content: "배달완료";
  font-size: 1.6rem;
  color: #b5b5b5;
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

.order-container[data-status="order"]
  .step[data-step="3"]
  .step-label.pickup:after,
.order-container[data-status="cooking"]
  .step[data-step="3"]
  .step-label.pickup:after,
.order-container[data-status="ready"]
  .step[data-step="3"]
  .step-label.pickup:after,
.order-container[data-status="pickup"]
  .step[data-step="3"]
  .step-label.pickup:after {
  content: "픽업완료";
  font-size: 1.6rem;
  color: #b5b5b5;
  transition: color 0.3s ease;
  position: absolute;
  left: 0;
  text-align: center;
  width: 100%;
}

/* 조리중 상태 */
.order-container[data-status="cooking"] .progress-line-active {
  width: 33.33%;
}

.order-container[data-status="cooking"] .status-mover {
  left: calc(33.333333% - 2rem);
  --bubble-text: "맛있게 조리 중이에요!";
}

.order-container[data-status="cooking"] .status-small::after {
  content: "";
  background-image: url("../../assets/img/img-status-cooking.webp");
}

.order-container[data-status="cooking"] .status-small::before {
  content: "맛있게 조리 중이에요!";
}

.order-container .step[data-step="0"] .step-circle {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

/* order: 0단계 체크 표시 */
.order-container[data-status="order"] .step[data-step="0"] .step-circle::after {
  opacity: 0;
}

/* cooking: 0,1단계 체크 표시 */
.order-container[data-status="cooking"]
  .step:is([data-step="0"], [data-step="1"])
  .step-circle::after {
  opacity: 0;
}

/* ready: 0,1,2단계 체크 표시 */
.order-container[data-status="ready"]
  .step:is([data-step="0"], [data-step="1"], [data-step="2"])
  .step-circle::after {
  opacity: 0;
}

/* pickup: 0~3단계 전부 체크 표시 */
.order-container[data-status="pickup"] .step .step-circle::after {
  opacity: 0;
}

.order-container[data-status="cooking"] .step[data-step="1"] .step-circle {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

/* 조리완료& 배달중 상태 */
.order-container[data-status="ready"] .progress-line-active,
.order-container[data-status="delivery"] .progress-line-active {
  width: 66.66%;
}

.order-container[data-status="ready"] .status-mover,
.order-container[data-status="delivery"] .status-mover {
  left: calc(66.6666666666% - 5rem);
}

.order-container[data-status="ready"] .status-mover::after {
  left: -8%;
  transform: rotate(90deg);
}

.order-container[data-status="ready"] .status-small::after {
  content: "";
  background-image: url("../../assets/img/img-status-ready.webp");
}

.order-container[data-status="ready"] .status-small::before {
  content: "픽업해주세요!";
  left: -85%;
  /* transition: all 0s; */
  border-radius: 1.2rem 1.2rem 0 1.2rem;
}

.order-container[data-status="delivery"] .status-small::after {
  content: "";
  background-image: url("../../assets/img/img-status-delivery.webp");
}

.order-container[data-status="delivery"] .status-small::before {
  content: "열심히 가고 있어요!";
  // left: -95%;
  left: -5.7rem;
  border-radius: 1.2rem 1.2rem 0 1.2rem;
}

.order-container[data-status="delivery"] .status-mover::after {
  // left: 12%;
  left: 0.6rem;
  transform: rotate(90deg);
}

.order-container[data-status="ready"] .step[data-step="0"] .step-circle,
.order-container[data-status="ready"] .step[data-step="1"] .step-circle,
.order-container[data-status="delivery"] .step[data-step="0"] .step-circle,
.order-container[data-status="delivery"] .step[data-step="1"] .step-circle {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

.order-container[data-status="ready"] .step[data-step="2"] .step-circle,
.order-container[data-status="delivery"] .step[data-step="2"] .step-circle {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

/* 픽업완료 상태 */
.order-container[data-status="pickup"] .progress-line-active {
  width: 100%;
}

.order-container[data-status="pickup"] .status-mover {
  left: calc(100% - 7rem);
}

.order-container[data-status="pickup"] .status-small::before {
  content: "픽업이 완료되었어요!";
}

.order-container[data-status="pickup"] .step .step-circle {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
}

/* 픽업완료 상태에서는 진행 UI 전체 감추기 */
.order-container[data-status="pickup"] .progress-container,
.order-container[data-status="fin"] .progress-container,
.order-container[data-status="cancel"] .progress-container {
  display: none;
}

/* 한 줄 문구 스타일 강화(선택) */
.order-container[data-status="pickup"] .status-display .status-msg,
.order-container[data-status="fin"] .status-display .status-msg,
.order-container[data-status="cancel"] .status-display .status-msg {
  font-size: 1.6rem;
  font-weight: 700;
  margin: 1.6rem 0 0 0;
  padding: 2rem 4.4rem;
  text-align: left;
  font-weight: bold;
}

.order-container[data-status="pickup"] .status-display .status-msg,
.order-container[data-status="fin"] .status-display .status-msg{
  background-color: #f6f5fc;
}

.order-container[data-status="cancel"] .status-display .status-msg {
  background-color: #fff6f4;
}

.order-container[data-status="cancel"] .status-display {
  color: var(--primary)
}

/* 완료류(픽업/배달완료)일 때 check만 보이기 */
.order-container[data-status="pickup"] .status-display.check,
.order-container[data-status="fin"] .status-display.check {
  display: block;
}

/* 취소일 때 cancel만 보이기 */
.order-container[data-status="cancel"] .status-display.cancel {
  display: block;
}

.order-detail-container {
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
}

.order-detail-container p {
  margin-bottom: 1.6rem;
  color: #0d0d0d;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: left;
}

.order-container .status-display .order-detail-container {
  display: block;
}

.order-detail-date,
.order-detail-number {
  display: flex;
  gap: 0.8rem;
}

.order-detail-number {
  margin-top: 4px;
}

.order-detail-date li:first-of-type,
.order-detail-number li:first-of-type {
  width: 8rem;
  color: #818181;
  font-size: 1.6rem;
  font-weight: normal;
  text-align: left;
}

.order-detail-date li:last-of-type,
.order-detail-number li:last-of-type {
  color: #0d0d0d;
  font-size: 1.6rem;
  font-weight: normal;
}

/* 컨트롤 버튼 */
.controls {
  text-align: center;
  margin-top: 4rem;
  display: flex;
  gap: 0.4rem;
  justify-content: space-between;
  max-width: 32.8rem;
  margin: 0 auto;
  padding-top: 3rem;
}

.control-btn {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.4em 0.6rem;
  border-radius: 0.8rem;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  transition: background 0.3s ease;
}

.control-btn:hover {
  background: #553c9a;
}

.status-display {
  font-size: 1.6rem;
  font-weight: bold;
  color: var(--primary);
  position: relative;
  // display: none; //26-03-26 배달 완료 처리 문구 안나와서 주석처리
}

.order-container[data-status="pickup"] .status-display .status-msg:before,
.order-container[data-status="fin"] .status-display .status-msg:before {
  content: "";
  position: absolute;
  background-image: url("../../assets/img/ic-24-done.webp");
  background-size: 2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  left: 1.6rem;
}

.order-container[data-status="cancel"] .status-display .status-msg:before {
  content: "";
  position: absolute;
  background-image: url("../../assets/img/ic-24-cancel.webp");
  background-size: 2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  left: 1.6rem;
}

/* 1) 파형 애니메이션 키프레임 */
@keyframes wavePulse {
  0% {
    /* 동일 개수의 그림자 레이어를 유지해야 부드럽게 인터폴레이션됨 */
    box-shadow:
      0 0 0 0rem rgba(70, 78, 193, 0.35),
      0 0 0 0rem rgba(70, 78, 193, 0.20),
      0 0 0 0rem rgba(70, 78, 193, 0.10);
  }
  70% {
    /* 바깥으로 퍼지며 투명해짐*/
    box-shadow:
      0 0 0 0.6rem rgba(70, 78, 193, 0.0),
      0 0 0 1.2rem rgba(70, 78, 193, 0.0),
      0 0 0 1.8rem rgba(70, 78, 193, 0.0);
  }
  100% {
    /* 루프 재시작을 위해 원점으로 복귀 */
    box-shadow:
      0 0 0 0rem rgba(70, 78, 193, 0.0),
      0 0 0 0rem rgba(70, 78, 193, 0.0),
      0 0 0 0rem rgba(70, 78, 193, 0.0);
  }
}

/* 1) 키프레임 */
@keyframes stepLabelBlink {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.5; }
}

/* 현재 단계에만 파형이 반복되도록 */
.order-container[data-status="order"] .step[data-step="0"] .step-circle {
  animation: wavePulse 2.4s ease-out infinite;
}

.order-container[data-status="cooking"] .step[data-step="1"] .step-circle {
  animation: wavePulse 2.4s ease-out infinite;
}

.order-container[data-status="ready"] .step[data-step="2"] .step-circle {
  animation: wavePulse 2.4s ease-out infinite;
}

.order-container[data-status="delivery"] .step[data-step="2"] .step-circle {
  animation: wavePulse 2.4s ease-out infinite;
}

/* 픽업완료에도 표시하려면 주석 해제 */
.order-container[data-status="pickup"] .step[data-step="3"] .step-circle {
  animation: wavePulse 2.4s ease-out infinite;
}

/* 현재 단계에만 점멸 반복되도록
.order-container[data-status='order']
  .step[data-step='0'] .step-label { animation: stepLabelBlink 2s ease-out infinite; }

.order-container[data-status='cooking']
  .step[data-step='1'] .step-label { animation: stepLabelBlink 2s ease-out infinite; }

.order-container[data-status='ready']
  .step[data-step='2'] .step-label { animation: stepLabelBlink 2s ease-out infinite; }

.order-container[data-status='delivery']
  .step[data-step='2'] .step-label { animation: stepLabelBlink 2s ease-out infinite; }
*/

/* 픽업완료에도 표시하려면 주석 해제 */
.order-container[data-status="pickup"] .step[data-step="3"] .step-label {
  animation: stepLabelBlink 2s ease-out infinite;
}

.h-8px {
  height: 8px;
  background-color: #f0f0f0;
}

.btn-map {
  width: 12.4rem;
  height: 4rem;
  padding: 0.8rem 1.6rem;
  border-radius: 0.8rem;
  border: solid 1px #ddd;
  background-color: #fff;
  font-size: 1.6rem;
}

.map-container {
  display: flex;
  align-items: center;
  margin: -5rem 16px 0px 16px;
  justify-content: space-between;
  border-top: 1px solid #d9d9d9;
  padding-top: 12px;
  padding-bottom: 16px;
}

.location {
  width: 17.6rem;
  position: relative;
  font-size: 1.6rem;
  padding-left: 2rem;
  text-align: left;
}

.location:before {
  content: "";
  position: absolute;
  background-image: url("../../assets/img/ic-24-distance.svg");
  background-size: 1.8rem;
  width: 1.8rem;
  height: 2.4rem;
  left: 0;
}

.time-container {
  margin-bottom: 1.6rem;
}

.order-container[data-status="fin"] .time-container,
.order-container[data-status="pickup"] .time-container,
.order-container[data-status="cancel"] .time-container {
  display: none;
}

.time-container .title {
  font-size: 2.2rem;
  color: var(--primary);
  font-weight: bold;
  //margin-top: 1.6rem; //2026-03-25
  text-align: left;
}

.time-container .sub-title {
  font-size: 1.4rem;
  color: #818181;
  font-weight: normal;
  text-align: left;
  margin-top: 0.8rem;
}

.btn-check-bill {
  width: 100%;
  font-size: 1.6rem;
  font-weight: normal;
  text-align: center;
  color: #0d0d0d;
  border: solid 1px #ddd;
  padding: 1rem 1.6rem;
  margin-top: 1.6rem;
  // display: none;
}

.orderHistoryDetail .orderList .li {
  padding-top: 16px;
}

/* 종결(픽업완료/배달완료/취소)일 때 버튼 보이기 */
.order-container[data-status="pickup"] ~ .cusCnt .btn-check-bill,
.order-container[data-status="fin"] ~ .cusCnt .btn-check-bill,
.order-container[data-status="cancel"] ~ .cusCnt .btn-check-bill {
  display: block;
}

// 2026-03-23 주문현황
.step {
  &-container {
    padding: 20px 16px 16px;
    margin-bottom: 16px;
    background-color: var(--primary-light);
    .map-container {
      margin: 0;
      padding: 12px 0 0;
      .btn-map {
        width: auto;
      }
    }
  }
  &-box {
    position: relative;
    margin-bottom: 16px;
  }
  &-list {
    --step-count: 4;
    --step-gap: 8px;
    --step-gap-total: calc((var(--step-count) - 1) * var(--step-gap));
    --step-width: calc(100% - var(--step-gap-total));
    --step-half: calc(var(--step-count) * 2);
    position: relative;
    display: flex;
    align-items: start;
    gap: var(--step-gap);
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 4px;
      left: calc(var(--step-width) / var(--step-half));
      right: calc(var(--step-width) / var(--step-half));
      height: 2px;
      background-color: #ddd;
    }
    &::after {
      background-color: var(--primary);
      transform-origin: left center;
      transform: scaleX(0);
      transition: transform 0.8s ease-in-out;
    }
    li {
      flex: 1;
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 10px;
      span {
        font-size: 15px;
        text-align: center;
      }
      &:before {
        content: "";
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        height: 10px;
        background-color: #ddd;
        border-radius: 50%;
      }
    }
    @for $step from 1 through 4 {
      &.step-#{$step} {
        @if $step > 1 {
          &::after {
            transform: scaleX(($step - 1) / 3);
          }
        }
        @for $i from 1 through $step {
          li:nth-child(#{$i}) {
            &:before {
              background-color: var(--primary);
            }
          }
        }
        @if $step > 1 {
          @for $i from 1 through ($step - 1) {
            li:nth-child(#{$i}) span {
              color: rgba(13, 13, 13, 0.6);
            }
          }
        }
        li:nth-child(#{$step}) {
          &:before {
            animation: wavePulse 2.4s ease-out infinite;
          }
          span {
            color: var(--primary);
            font-weight: bold;
          }
        }
      }
    }
    &.col-3 {
      --step-count: 3;
      --step-gap: 28px;
      @for $step from 1 through 3 {
        &.step-#{$step} {
          @if $step > 1 {
            &::after {
              transform: scaleX(($step - 1) / 2);
            }
          }
        }
      }
    }
  }
}
</style>

<style>
:root {
  font-size: 10px !important;
}

#header {
  height: 5.6rem;
}

@media (max-width: 359.8px) {
  :root {
    font-size: 8.75px !important;
  }
}
</style>
